import React from 'react';
import * as AwsS3 from "../../inc/AwsS3";
import toast from "react-hot-toast";
import {PutObjectCommand} from "@aws-sdk/client-s3";
import {Buffer} from "buffer";
import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";

export default function ExportS3() {
    let id = 1;

    let awsS3Config = {
        //accessKeyId: "AKIATTMIJULXFDVLTZNH",
        //bucket: "apthai-stgbucket-thai",
        //folderContentId: "Landing/SocialTags/ContentID",
        //region: "ap-southeast-7",
        //secretKey: "c6E4BTUeJ+jZJ8CRa1EpZde3N/1C8qaPFhCPzI+t",
        //url: "https://apthai-stgbucket-thai.s3.ap-southeast-7.amazonaws.com/",
        //version: "2012-10-17"
    };

    React.useEffect(() => {
        //console.log(awsS3Config);

        (async function() {
            try {

                const awsS3Config = await getView();
                if(awsS3Config.status) {
                    await masterUTMCSV(awsS3Config);
                    await adsCampaignGroupCSV(awsS3Config);
                    await adsSetNamingGroupCSV(awsS3Config);
                    await adsNamingCSV(awsS3Config);
                    await generateURLCSV(awsS3Config);
                    await campaignNamingCSV(awsS3Config);
                    await adSetNamingCSV(awsS3Config);
                    await generateUTMCampaignCSV(awsS3Config);
                }

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/awsS3Export/data', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    function cleansingData(str = '') {
        if(str) {
            str = str.trim(); // remove left right space
            str = str.replace(',', ''); // remove comma
            str = str.replace(/\n/g, ''); // remove enter or newline
            str = str.replace(/["']/g, ''); // remove single quote / double quote
            if(!isNaN(str)) {
                //console.log('number');
            }
            else {
                //console.log('string');
                str = '"' + str + '"';
            }
        }
        else {
            str = '""';
        }

        return str;
    }

    //01-All_Master_UTM - All
    async function masterUTMCSV(awsS3Config) {
        console.log('masterUTMCSV');
        let result = await getAllMasterUTM();
        //console.log(result);

        //ID,UTM_Source_type,code,Owner,UTM_Source,UTM,CreateBy,Create_Date
        //1,"facebook","F001","Admin - Owner","Source Type","Source","admin","2025-03-31 10:12"
        //2,"tiktok","T001","Admin - Owner","Source Type","Source","admin","2025-03-31 10:15"

        let header = 'ID,UTM_Source_type,code,Owner,UTM_Source,UTM,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {
                let data = [];

                let owners = [];
                if(rs.items) {
                    for(let item of rs.items) {
                        owners.push(item.data.name);
                    }
                }

                data.push(rs.id);
                data.push(cleansingData(rs.name));
                data.push(rs.code ? '"' + rs.utmSource.prefix + rs.code + '"' : '');
                data.push(owners.length > 0 ? '"' + owners.join(',') + '"' : '""');
                data.push(cleansingData(rs.utmSource?.name));
                data.push(cleansingData(rs.utm?.name));
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Master_UTM_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/MasterUTM/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(awsS3Config);
                console.log(result);
            }
        }
    }
    async function getAllMasterUTM() {
        const response = await fetch(Config.url.API_URL +'/api/utmSourceType/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //02-All_Master_Campaign_Naming_Group - All
    async function adsCampaignGroupCSV(awsS3Config) {
        console.log('adsCampaignGroupItem');
        let result = await getAllAdsCampaignGroupItem();
        //console.log(result);

        //ID,Group_item_name,Group_name,Type,CreateBy,Create_Date
        //1,"Test_Sep_20230905","Campaign Setname Group","special","admin","2025-03-31 10:12"
        //2,"BAS_Test_G3","CBAS_ADH_Grouptest","Promotion","admin","2025-03-31 10:12"

        let header = 'ID,Group_item_name,Group_name,Type,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {
                let data = [];
                data.push(rs.id);
                data.push(cleansingData(rs.name));
                data.push(cleansingData(rs.group?.name));
                data.push(cleansingData(Utils.adsNamingCampaignTypeName(rs.group?.typeId)));
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Master_Campaign_Naming_Group_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/MasterCampaign/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(result);
            }
        }
    }
    async function getAllAdsCampaignGroupItem() {
        const response = await fetch(Config.url.API_URL +'/api/adsCampaignGroupItem/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //03-All_Master_AdSet_Naming_Group - All
    async function adsSetNamingGroupCSV(awsS3Config) {
        console.log('adsSetNamingGroupCSV');
        let result = await getAllAdsSetNamingGroupItem();
        //console.log(result);

        //ID,Group_item_name,Group_name,Type,CreateBy,Create_Date
        //8,"test1","Ads Setname Group","Project","xxxxx","2025-03-31 10:12"
        //9,"Alw1","BAS_Test_Adset_Group_Alw","Project","xxxxx","2025-03-31 10:12"

        let header = 'ID,Group_item_name,Group_name,Type,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {
                let data = [];
                data.push(rs.id);
                data.push(cleansingData(rs.name));
                data.push(cleansingData(rs.group?.name));
                data.push(cleansingData(Utils.adsNamingCampaignTypeName(rs.group?.typeId)));
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Master_AdSet_Naming_Group_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/MasterAdSet/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(result);
            }
        }
    }
    async function getAllAdsSetNamingGroupItem() {
        const response = await fetch(Config.url.API_URL +'/api/adsSetnameGroupItem/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //04-All_Master_Ads.csv - All
    async function adsNamingCSV(awsS3Config) {
        console.log('adsNamingCSV');
        let result = await getAllAdsNaming();
        //console.log(result);

        //ID,Ads_Naming,Type,CreateBy,Create_Date
        //12,"UATPlatform","SetName, Campaign","xxxxx","2025-03-31 10:12"
        //15,"BG","SetName, Campaign","xxxxx","2025-03-31 10:12"

        let header = 'ID,Ads_Naming,Type,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {

                let types = [];
                if(rs.items) {
                    for(let item of rs.items) {
                        types.push(Utils.adsNamingTypeName(item.typeId));
                    }
                }

                let data = [];
                data.push(rs.id);
                data.push(cleansingData(rs.name));
                data.push(types.length > 0 ? '"' + types.join(',') + '"' : '""');
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Master_Ads_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/MasterAds/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(result);
            }
        }
    }
    async function getAllAdsNaming() {
        const response = await fetch(Config.url.API_URL +'/api/adsNaming/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //05-Generate_URL[daily] - Yesterday
    async function generateURLCSV(awsS3Config) {
        console.log('GenerateURL');
        let result = await getAllGenerateURL();
        //console.log(result);

        //ID,Type,URL,CreateBy,Create_Date
        //12,"Project","https://www.apdigital.net/th/townhome/grande-pleno-phaholyothin-rangsit-test?utm_source=facebook_affpage&utm_medium=A0004_O0012_M0038_paid&utm_campaign=T0007_0199P11_C00000000000019&utm_content=richmessage_financial&utm_term=Studio","xxxxx","2025-03-31 10:12"

        let header = 'ID,Type,URL,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {
                let data = [];
                let fullUrl = rs.url+'?'+rs.params;
                data.push(rs.id);
                data.push(cleansingData(Utils.generateUTMType(rs.typeId)));
                data.push(cleansingData(fullUrl));
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                //let date = new Date();
                let date = new Date(new Date().setDate(new Date().getDate() - 1));
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Generate_URL_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/GenerateURL/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(result);
            }
        }
    }
    async function getAllGenerateURL() {
        const response = await fetch(Config.url.API_URL +'/api/utmGenerate/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                yesterday: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //06-Campaign_Naming[daily] - Yesterday
    async function campaignNamingCSV(awsS3Config) {
        console.log('Campaign Naming');
        let result = await getAllCampaignNaming();
        //console.log(result);

        //ID,Type,CampaignName,CreateBy,Create_Date
        //99,"Project","TH_townhome-donmuang-rangsit-lamlukka|Engage_Test_facebook|SetNameType01_[ST]","xxxxx","2025-03-31 10:12"
        //98,"Promotion","CD2_th-single-detached-house-zone-suksawat-rama2|WebsiteVisit-WebsiteRegister_Test_Google|SetNameType01_[ST]","xxxxx","2025-03-31 10:12"

        let header = 'ID,Type,CampaignName,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {
                let data = [];
                data.push(rs.id);
                data.push(cleansingData(Utils.adsNamingCampaignTypeName(rs.typeId)));
                data.push(cleansingData(rs.params));
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                //let date = new Date();
                let date = new Date(new Date().setDate(new Date().getDate() - 1));
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Campaign_Naming_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/CampaignNaming/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(result);
            }
        }
    }
    async function getAllCampaignNaming() {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingCampaign/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                yesterday: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //07-Generate_AdSet_Naming - Yesterday
    async function adSetNamingCSV(awsS3Config) {
        console.log('AdSet Naming');
        let result = await getAllAdSetNaming();
        //console.log(result);

        //ID,Type,AdSet_Name,CreateBy,Create_Date
        //99,"Project","TH_townhome-donmuang-rangsit-lamlukka|Engage_Test_facebook|SetNameType01_[ST]","xxxxx","2025-03-31 10:12"
        //98,"Promotion","CD2_th-single-detached-house-zone-suksawat-rama2|WebsiteVisit-WebsiteRegister_Test_Google|SetNameType01_[ST]","xxxxx","2025-03-31 10:12"

        let header = 'ID,Type,AdSet_Name,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {
                let data = [];
                data.push(rs.id);
                data.push(cleansingData(Utils.adsNamingCampaignTypeName(rs.typeId)));
                data.push(cleansingData(rs.params));
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                //let date = new Date();
                let date = new Date(new Date().setDate(new Date().getDate() - 1));
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Generate_AdSet_Naming_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/AdSetNaming/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(result);
            }
        }
    }
    async function getAllAdSetNaming() {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingSetName/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                yesterday: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //08-Generate_UTM&Campaign - Yesterday
    async function generateUTMCampaignCSV(awsS3Config) {
        console.log('Generate UTM & Campaign');
        let result = await getAllGenerateUTMCampaign();
        //console.log(result);

        //ID,Type,Campaign_type,Campaign_name,CreateBy,Create_Date
        //12,"Project","UTM","https://www.apdigital.net/th/townhome/grande-pleno-phaholyothin-rangsit-test?utm_source=facebook_affpage&utm_medium=A0004_O0012_M0038_paid","Admin","2025-03-31 10:12"
        //13,"Special","Campaign","Agency1|CD_Agency1_th-ap-brand_none_Awareness_facebook_Carousel_xxxx_[ST]|1036P01","Admin","2025-03-31 10:12"

        let header = 'ID,Type,CampaignName,AdsSet,UTM,CreateBy,Create_Date\n';

        if(result) {
            let arr = [];
            for(let rs of result) {
                let utmUrl = '';
                let campaignUrl = '';
                let adssetUrl = '';
                if(rs.generateTypeUTM) {
                    utmUrl = rs.url + '?' + rs.paramsUTM + (rs.addLine ? '#addline':'');
                }
                if(rs.generateTypeCampaign) {
                    campaignUrl = rs.paramsCampaign;
                }
                if(rs.generateTypeAdsset) {
                    adssetUrl = rs.paramsAdsset;
                }

                let data = [];
                data.push(rs.id);
                data.push(cleansingData(Utils.generateUTMType(rs.typeId)));
                data.push(cleansingData(campaignUrl));
                data.push(cleansingData(adssetUrl));
                data.push(cleansingData(utmUrl));
                data.push(cleansingData(rs.user?.contact));
                data.push(cleansingData(Utils.dateYMDHI(rs.createdAt, '-')));
                arr.push(data.join(','));
            }
            let rows = arr.join('\n');
            let csvString = header + rows;
            console.log(csvString);

            const base64String = 'data:text/csv;base64,' + Buffer.from(csvString).toString('base64');
            const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
            const type = base64String.split(';')[0].split(':')[1];

            if(base64Data && type) {
                //let date = new Date();
                let date = new Date(new Date().setDate(new Date().getDate() - 1));
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if(month < 10) {
                    month = '0' + month;
                }
                if(day < 10) {
                    day = '0' + day;
                }
                let dateString = year + '' + month + '' + day;

                let fileName = 'Generate_Campaign_Naming_' + dateString + '.csv';
                let params = {
                    ContentEncoding: 'base64',
                    ContentType: type,
                    Bucket: awsS3Config.bucket,
                    Key: awsS3Config.folderContentId + '/NewCampaignNaming/' + fileName,
                    Body: base64Data
                };

                let result = await AwsS3.s3Client(awsS3Config).send(new PutObjectCommand(params));
                console.log(result);
            }
        }
    }
    async function getAllGenerateUTMCampaign() {
        const response = await fetch(Config.url.API_URL +'/api/generate/listingAll', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                yesterday: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
            <>
                <h1>Hello Export S3</h1>
            </>
    )
} 